import React, { PropsWithChildren } from 'react';
export { default } from './Table';
import styles from './Table.module.scss';

export const Hidden: React.FC<PropsWithChildren> = ({ children }) => (
  <div className={styles.hidden}>{children}</div>
);
